import { render } from "./RegulationNewsType.vue?vue&type=template&id=78cf9c7a"
import script from "./RegulationNewsType.vue?vue&type=script&lang=js"
export * from "./RegulationNewsType.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__